/**
 * diffRowExpansion — the shared expand/collapse state of ONE diff row.
 *
 * A property diff has two sides that must always show the same amount of text:
 * expanding "current" without expanding "proposed" makes the columns
 * un-comparable, which is the whole reason `PropertyValueLabel` grew its
 * `hideExpandButton` prop. The row owns a single toggle
 * ({@link DiffSection}'s row item) and publishes its state here; each side's
 * value renderer reads it.
 *
 * Context rather than a prop so the row's `currentValue` / `proposedValue`
 * stay plain ReactNodes — passing them as `(isExpanded) => <Value/>` render
 * functions would make every diff cell a component defined during render.
 *
 * Defaults to collapsed, so a value renderer used outside a diff row behaves
 * exactly as it does inside a collapsed one.
 */

import { createContext, useContext } from 'react';

const DiffRowExpansionContext = createContext(false);

export const DiffRowExpansionProvider = DiffRowExpansionContext.Provider;

// eslint-disable-next-line react-refresh/only-export-components -- hook co-located with its provider
export function useDiffRowExpanded(): boolean {
  return useContext(DiffRowExpansionContext);
}
